import { axios } from 'api'
import ExplorePage from 'components_v1/pageLevelComponents/explore/ExplorePage'
import { useCommonEntryContext } from 'components_v2/common'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const Main = styled.div``
const ExploreView = () => {
  const { user, searchParams, globalState, setGlobalState } =
    useCommonEntryContext()
  const defaultOrder = searchParams?.get('order') || 'date'
  const programFinderData = globalState?.program_finder_data

  const [props, setProps] = useState(null)
  useEffect(() => {
    if (programFinderData) {
      setProps(programFinderData)
      return
    }
    axios
      .get('/plans/program_finder/data', { load: true })
      .then((res) => {
        setProps(res.data)
        setGlobalState('program_finder_data', res.data)
      })
      .catch((err) => console.log(err))
  }, [programFinderData, setGlobalState])
  if (!props) return null
  return (
    <Main className='new-explore explore-cold-start'>
      <ExplorePage
        pageVersion='filter'
        currentUser={user}
        {...props}
        baseUrl={'/explore'}
        defaultOrder={defaultOrder}
      />
    </Main>
  )
}

export default ExploreView
